import { httpClient } from '@/services/http/httpClient'

type RegisterAutonomouParams = {
  name: string
  email?: string
  registration?: string
  password?: string
  areaId: string
  departamentId: string
  registerTokenId: string
}

type RegisterAutonomouResponse = {
  name: string
  email: string
  registration: string
  areaId: string
  departamentId: string
}

export async function registerAutonomou(params: RegisterAutonomouParams) {
  const { data } = await httpClient.post<RegisterAutonomouResponse>(
    `/users/public/self-registration?registerTokenId=${params.registerTokenId}`,
    params,
  )

  return data
}
